import { getStoneAccount } from '../services/get-stone-account'
import { type Entity, type OptIns, type Subject } from '../types'

type LegacySession = { subject: Subject<OptIns>; entity: Entity<OptIns> }

const fetchStoneAccountId = async (globalId: string) => {
  try {
    const data = await getStoneAccount({ globalId })

    return data?.id ? data : undefined
  } catch (error) {
    return undefined
  }
}

export const withLegacyStoneAccount = async (session: LegacySession): Promise<LegacySession> => {
  const data = await fetchStoneAccountId(session?.entity?.id)

  if (!data?.id) return session

  return {
    ...session,
    entity: {
      ...session.entity,
      stoneAccount: { id: data.id, situation: data.situation, originBrand: data.originBrand, paymentProfiles: [] }
    }
  }
}
